import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import LocationName from '~/components/LocationName'
import * as LocationRadioListStyles from '~/components/LocationsRadioList/styles'
import Panel from '~/components/Panel'
import { Badge } from '~/components/UI/Badge'

const PromotionLocations = () => {
  const { promotion } = useSelector(state => state.promotional)

  const labelLocations = useMemo(() => {
    const length = promotion?.location_ids_raw?.length || 0

    switch (true) {
      case length === 1:
        return `${length} local selecionado`

      case length > 1:
        return `${length} locais selecionados`

      default:
        return 'Todos os locais'
    }
  }, [promotion])

  return (
    <Panel
      title="Locais participantes"
      isCollapsible={!!promotion?.location_ids_raw?.length}
      initialCollapsibleState={false}
      headerSideContent={<Badge>{labelLocations}</Badge>}
    >
      {!!promotion?.location_ids_raw?.length && (
        <LocationRadioListStyles.LocationGroup>
          {promotion?.location_ids_raw.map(item => (
            <LocationRadioListStyles.LocationItem key={item}>
              <div>
                <label>
                  <LocationName locationId={item} />
                </label>
              </div>
            </LocationRadioListStyles.LocationItem>
          ))}
        </LocationRadioListStyles.LocationGroup>
      )}
    </Panel>
  )
}

export default PromotionLocations
